import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { HashRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "@/contexts/LanguageContext";
import Home from "@/pages/Home";
import Fondatrice from "@/pages/Fondatrice";
import Ceremonies from "@/pages/Ceremonies";
import ActionsHumanitaires from "@/pages/ActionsHumanitaires";
import Equipe from "@/pages/Equipe";
import Galerie from "@/pages/Galerie";
import NotFound from "@/pages/not-found/Index";
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import _HomeIndex from "@/pages/home/Index";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <LanguageProvider>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <HashRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/fondatrice" element={<Fondatrice />} />
            <Route path="/ceremonies" element={<Ceremonies />} />
            <Route path="/actions" element={<ActionsHumanitaires />} />
            <Route path="/equipe" element={<Equipe />} />
            <Route path="/galerie" element={<Galerie />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </HashRouter>
      </TooltipProvider>
    </LanguageProvider>
  </QueryClientProvider>
);

export default App;
